// import { Device } from "zebra-print";

import { Parcel } from "@/features/modules/parcel/objects/Parcel";

import { connect, createZplLabelFromParcel, getState, printLabel, setState } from "./methods";

export class ZebraPrintModel {
  public device: string | undefined = undefined;

  public async connect(): Promise<void> {
    return await connect();
  }

  public createZplLabelFromParcel(parcel: Parcel, d: (date: Date, format: string) => string, withBorders = false): string {
    return createZplLabelFromParcel(parcel, d, withBorders);
  }
  public getState(): "connected" | "disconnected" {
    return getState();
  }

  public async printLabel(zplLabel: string): Promise<void> {
    return await printLabel(zplLabel);
  }

  public setState(state: "connected" | "disconnected"): void {
    return setState(state);
  }
}

export const zebraPrintModel: ZebraPrintModel = new ZebraPrintModel();
